import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatDate, getInlineLoader } from "../Helpers";
import {
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_INBOX,
	STR_LEARN,
	STR_LEARN_2,
	STR_NEW,
	STR_NO_MESSAGES,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	async function markAsRead(notificationId) {
    await callApi("mark-notification-as-read", { notificationId }).then(response => {
      //..
      if(response.status === 1) {
        appContext.getCurrentUserData();
      }
    })
  }

  function isNew (notificationId) {
    const notifications = JSON.parse(appContext.currentUserData.notifications);
    const newNotifications = JSON.parse(appContext.currentUserData.newNotifications);
    
    //check if notification id exists in newNotification
    for (const _notification of newNotifications) {
      if(_notification.id === notificationId) {
        return true;
      }
    }

    return false;
  }

	useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])


	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
          paddingTop: "30px"
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								{STR_NOTIFICATIONS[appContext.language]}
							</h6>
						</div>

						<div className="col-md-12">
							
							{
								(appContext.currentUserData) ?
									(JSON.parse(appContext.currentUserData.notifications).length > 0) ?
										<>
											{
												JSON.parse(appContext.currentUserData.notifications).reverse().map((item, i) => {
													return (
														<div key={i} className="col-12">
															<div
																className="card"

																onClick={() => {
																	markAsRead(item.id);

																	if (item.navable) {
																		appContext.navTo({
																			item: item.navItem,
																			subItem: item.navSubItem,
																			extraItem: item.navExtraItem,
																			moreItem: item.navMoreItem,
																		})
																	}
																}}
															>
																<div
																	className="card-body"
																>
                                  <h6
                                    style={{
                                      fontSize: "12px"
                                    }}
                                    className="font-bold text-primary text-end text-muted"
                                  >
                                    {formatDate(item.timestamp)}
                                  </h6>

																	<h6
																		className=""
																		style={{
																			fontSize: "14px",
																		}}
																	>
																		{item.message[appContext.language]}
																	</h6>

																	{
																		(isNew(item.id)) ?
																		<h6
																			style={{
																				fontSize: "12px"
																			}}
																			className="font-bold text-primary"
																		>
																			{STR_NEW[appContext.language]}
																		</h6>
																		:""
																	}

																</div>
															</div>
														</div>
													)
												})
											}



										</>
										:
										<div className="col-12">
											<h6>{STR_NO_RECORD[appContext.language]}</h6>
										</div>
									:
									<div className="col-12 mSupportLoading" style={{ padding: "10px", paddingTop: "0px", paddingBottom: "20px" }}>
										{getInlineLoader()}
									</div>
							}
							
						</div>
					</div>

					

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}